import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'fs-fullscreen-icon',
  templateUrl: './fullscreen-icon.component.html',
  styleUrls: ['./fullscreen-icon.component.scss'],
})
export class FullscreenIconComponent {
  @Output()
  clicked = new EventEmitter<void>();

  onClick(): void {
    this.clicked.emit();
  }
}
